import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetOrCreateDirectChannelResponse {
  channel_id: number;
}

export default function useGetOrCreateDirectChannelApi() {
  const getOrCreateDirectChannel = async (
    otherUserId: number,
  ): Promise<number> => {
    const response = await ChessRestClient.post<GetOrCreateDirectChannelResponse>(
      '/inbox/get_or_create_direct_channel',
      {other_user_id: otherUserId},
    );
    if (response.data?.channel_id == null) {
      throw new Error('Failed to get or create channel');
    }
    return response.data.channel_id;
  };

  return useMutation(getOrCreateDirectChannel);
}
